import { render, staticRenderFns } from "./HallsNearby.vue?vue&type=template&id=48329558"
import script from "./HallsNearby.vue?vue&type=script&lang=ts"
export * from "./HallsNearby.vue?vue&type=script&lang=ts"
import style0 from "./HallsNearby.vue?vue&type=style&index=0&id=48329558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports